// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'view-design'
import iviewArea from 'iview-area'
import moment from 'moment'
import i18n from '@/locale'
import config from '@/config'
import importDirective from '@/directive'
import installPlugin from '@/plugin'
import 'view-design/dist/styles/iview.css'
import './index.less'
import '@/assets/icons/iconfont.css'
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(iviewArea);
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */
import TextTooltip from '_c/TextTooltip'
Vue.component("TextTooltip",TextTooltip);
/**
 * 全局格式化时间
 */
Vue.prototype.$moment = (date,format)=>{
  date = date || new Date(),
  format = format || "YYYY-MM-DD HH:mm";
  return moment(date).format(format)
};
/**
 * 全局格式化日期
 */
Vue.prototype.$momentDate = (date,format)=>{
  date = date || new Date(),
  format = format || "YYYY-MM-DD";
  return moment(date).format(format)
};
// 防重复点击(指令实现)
Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})
